import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserFirstName: Getter<UserState, RootState> = (state) =>
  state.current?.first_name || ''

export default getUserFirstName
